import { atomWithReset } from "jotai/utils";

export const loginOtpEmailAtom = atomWithReset("");
export const loginOtpExpirationTimeAtom = atomWithReset(0);
